"use strict";

var _interopRequireDefault = require("/var/lib/jenkins/workspace/pay-center-front-master/node_modules/@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _interopRequireWildcard2 = _interopRequireDefault(require("/var/lib/jenkins/workspace/pay-center-front-master/node_modules/@babel/runtime-corejs2/helpers/interopRequireWildcard"));

var _layout = _interopRequireDefault(require("@/layout"));

/** When your routing table is too long, you can split it into small modules **/
var orderManagementRouter = {
  type: 1,
  path: '/order-history-management',
  component: _layout.default,
  redirect: '/order-history-management/order-records-history',
  name: '',
  meta: {
    title: 'orderHistoryManagement',
    icon: 'g-order'
  },
  children: [{
    type: 2,
    path: 'order-records-history',
    component: function component() {
      return Promise.resolve().then(function () {
        return (0, _interopRequireWildcard2.default)(require('@/views/sms-order-history-management/recharge-order-records-history'));
      });
    },
    name: 'rechargeOrderHistory:view',
    meta: {
      title: 'orderRecordsHistory'
    },
    children: []
  }, {
    type: 2,
    path: 'order-notify-history',
    component: function component() {
      return Promise.resolve().then(function () {
        return (0, _interopRequireWildcard2.default)(require('@/views/sms-order-history-management/recharge-order-notify-history'));
      });
    },
    name: 'rechargeOrderNotifyHistory:view',
    meta: {
      title: 'orderNotifyHistory'
    },
    children: []
  }, {
    type: 2,
    path: 'refund-order-history-management',
    component: function component() {
      return Promise.resolve().then(function () {
        return (0, _interopRequireWildcard2.default)(require('@/views/sms-order-history-management/refund-order-history'));
      });
    },
    name: 'refundOrderHistory:view',
    meta: {
      title: 'refundOrderHistory'
    },
    children: []
  }]
};
var _default = orderManagementRouter;
exports.default = _default;